<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >

            <van-divider>请选择购买类型</van-divider>

            <van-radio-group v-model="buyType">
                <van-cell-group>
                    <van-cell :title="'购买单张'+'('+row.photo_service_price+'元)'" label="支付后仅可下载当前单张图片"  clickable @click="buyType = '1'">
                        <template #right-icon>
                            <van-radio  checked-color="#ffad19" name="1" />
                        </template>
                    </van-cell>
                    <van-cell :title="'购买当前赛区所有照片'+'('+row.photo_service_allprice+'元)'" label="支付后可下载该赛区所有图片"  clickable @click="buyType = '2'">
                        <template #right-icon>
                            <van-radio checked-color="#ffad19" name="2" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>

            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">确定支付</van-button>
            </div>
        </van-form>


        <PayDialog :show="payDialogShow" scene="activity_pic" :ids="orderIds" @onPayError="onPayError" @onPaySuccess="onPaySuccess"
                   @onPayClose="onPayClose"/>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .fapiao-tip-wrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        line-height: 36px;
        padding: 0.2rem;
        font-size: 14px;
        color: #666;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            PayDialog,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                payDialogShow:false,
                buyType:0,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                row:{
                    order:{

                    },
                    photo_service_price:'',
                    photo_service_allprice:'',
                },
                activity_id :0,
                topic_id :0,
                index :0,
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.activity_id  = this.$route.query.activity_id;
            that.topic_id  = this.$route.query.topic_id;
            that.index  = this.$route.query.index;
            this.fetch();
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;

                if(this.buyType==0){
                    Toast.fail('请选择购买类型');
                    return ;
                }
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/activity/picordersave', {
                    activity_id:that.activity_id,
                    topic_id:that.topic_id,
                    index:that.index,
                    buy_type:that.buyType,
                }, (res) => {
                    that.saveLoading = false;

                    that.orderIds = res.data.ids;
                    that.payDialogShow = true;

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/activity/activityPicOrderForm', {
                    activity_id:that.activity_id,
                    topic_id:that.topic_id,
                    index:that.index,
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },

            onPayError() {
                let that = this;
                console.log('onPayError 支付失败');
                that.payDialogShow = false;

                that.$toast('支付失败');

            },
            onPaySuccess() {
                let that = this;
                console.log('onPaySuccess 支付成功');
                that.payDialogShow = false;


                setTimeout(function () {
                    rbLink({
                        name:'',
                        query:{
                        }
                    },'back')

                },500);

            },
            onPayClose() {
                let that = this;
                console.log('onPayClose 支付关闭');
                that.payDialogShow = false;


            }


        }
    }
</script>



// WEBPACK FOOTER //
// ActivityPicOrderForm.vue?2d35f4b4